import { combineReducers } from 'redux';
import overlayReducer from './redux/reducer';

export default combineReducers({ overlay: overlayReducer });
